export default "__VITE_ASSET__ChNQZJNc__"